import { Link } from '@mui/material'

type Props = {
  href?: string
  value?: string
}
export const ExternalLinkCell = ({ href, value }: Props) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => e.stopPropagation()}
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.2',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        color: 'primary.main',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      {value}
    </Link>
  )
}
